import { jsx as _jsx } from "react/jsx-runtime";
export const CdpMobileViewCss = () => (_jsx("style", { children: `
        header {
            display: none;
        }
    ` }));
export const CdpRouterViewCss = () => (_jsx("style", { children: `
        header {
          display: none;
        }
        footer {
          display: none;
        }
    ` }));
